<template>
    <div id="demo-basic-card">
        <div id="dashboard-analytics">
             <div class="vx-row mt-4">
                <vs-table stripe :data="rowDatas" class="w-full" :noDataText="this.$t('noData')">
                    <template>
                        <vs-tr style="background:#f3f2f7 !important">
                            <vs-th class="md:w-1/12" v-for="(header, indexHeader) in headerTable" :key="indexHeader">
                                <span>{{header.label}}</span>
                            </vs-th>
                        </vs-tr>
                        <vs-tr v-for="(warning, indexSource) in rowDatas" :key="indexSource">
                            <vs-td>
                                <span class="text-code ">{{warning.number}}</span>
                            </vs-td>
                            <vs-td>
                                <div class="component">
                                    <span class="text-code">{{warning.name}}</span>
                                </div>
                                <div class="component">
                                    <span class="type-source">{{warning.sourceName}}</span>
                                </div>
                            </vs-td>
                            <vs-td>
                                <span class="source-name">{{warning.source}}</span>
                            </vs-td>
                            <vs-td>
                                <span class="type-source">{{warning.rules}}</span>
                            </vs-td>
                             <vs-td>
                                <span class="type-source">{{warning.formality}}</span>
                            </vs-td>
                            <vs-td>
                                <span
                                class="badge"
                                :style="{background: `rgba(var(--vs-${warning.bg}),.15)`, color: `${warning.color}`}">
                                {{warning.status ? $t('warning.active') : $t('warning.inActive')}}</span>
                            </vs-td>
                            <vs-td>
                                <div class="component inline-image">
                                    <span class="mr-2">
                                        <img v-if="userInfo.photoURL" key="onlineImg" :src="userInfo.img || userInfo.photoURL" alt="user-img" width="20" height="20" class="rounded-full shadow-md cursor-pointer block" />
                                    </span>
                                    <span class="text-code">{{warning.createdBy}}</span>
                                </div>
                                <div class="component">
                                    <div class="vx-row">
                                        <div class="vx-col md:w-10/12 w-full">
                                             <span class="type-source">{{warning.createdDate}}</span>
                                        </div>
                                        <div class="vx-col md:w-2/12 w-full">
                                            <vs-dropdown class="cursor-pointer">
                                                <feather-icon
                                                icon="MoreVerticalIcon"
                                                class=""
                                                style="color: rgb(110 107 123);width: 1.2rem"
                                                >
                                                </feather-icon>
                                                <vs-dropdown-menu>
                                                <div class="component vx-card">
                                                    <ul style="min-width: 228px">
                                                    <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white border-bottom-dropdown" @click="updateFacebook(warning)">
                                                        <div class="vx-row">
                                                            <div class="vx-col md:w-10/12 w-full m-auto">
                                                                <span class="detail-user">{{ $t('warning.status') }}: </span>
                                                                <span class="detail-user"><b>{{warning.status ? $t('warning.active') : $t('warning.inActive')}}</b></span>
                                                            </div>
                                                            <div class="vx-col md:w-2/12 w-full cursor-pointer" v-if="warning.status" @click="updateStatus(warning)">
                                                                <feather-icon class="p-1 icon-custom-play" icon="PlayIcon"></feather-icon>
                                                            </div>
                                                            <div class="vx-col md:w-2/12 w-full cursor-pointer" v-else @click="updateStatus(warning)">
                                                                <feather-icon class="p-1 icon-custom-pause" icon="PauseIcon"></feather-icon>
                                                            </div>
                                                        </div>
                                                    </li>
                                                    <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white border-bottom-dropdown">
                                                        <div class="vx-row px-4">
                                                            <div class="component w-full">
                                                                <span class="infomation">{{ $t('warning.infomation').toUpperCase() }}</span>
                                                            </div>
                                                            <div class="component detail-user">
                                                                <span class="font-action">{{ $t('warning.createdBy') }}: {{warning.createdBy}}</span>
                                                            </div>
                                                            <div class="component detail-user">
                                                                <span class="font-action">{{ $t('warning.createdDate') }}: {{warning.createdDate}}</span>
                                                            </div>
                                                            <div class="component detail-user">
                                                                <span class="font-action">{{ $t('warning.recentlyModifited') }}: {{warning.createdBy}}</span>
                                                            </div>
                                                        </div>
                                                    </li>
                                                    <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white border-bottom-dropdown" @click="updateWarning(warning)">
                                                        <feather-icon
                                                        icon="Edit3Icon"
                                                        style="vertical-align:middle;width:1rem"
                                                        >
                                                        </feather-icon>
                                                        <span class="font-action ml-2 mt-1 text-action">{{ $t('warning.editRulesWarning')}}</span>
                                                    </li>
                                                    <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white border-bottom-dropdown " @click="copyWarning(warning)">
                                                        <feather-icon
                                                        icon="CopyIcon"
                                                        style="vertical-align:middle;width:1rem"
                                                        >
                                                        </feather-icon>
                                                        <span class="font-action ml-2 mt-1 text-action ">{{ $t('warning.copyWarning') }}</span>
                                                    </li>
                                                    <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="confirmDeleteRecord(warning)">
                                                        <feather-icon
                                                        icon="Trash2Icon"
                                                        style="vertical-align:middle;width:1rem"
                                                        >
                                                        </feather-icon>
                                                        <span class="font-action ml-2 mt-1 text-action">{{ $t('warning.deleteWarning')}}</span>
                                                    </li>
                                                    </ul>
                                                </div>
                                                </vs-dropdown-menu>
                                            </vs-dropdown>
                                        </div>
                                    </div>
                                </div>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </div>

            <div class="vx-row mt-2">
                <div class="vx-card custom-card">
                    <div class="vx-col md:w-1/2 w-full m-auto ml-4">
                        <div class="component">
                            <span class="content-page">{{ $t('warning.showing') }}: </span>
                            <span class="text-page">{{currentPage}} - {{currentPage * countElementPage}}/{{totalElements}} </span>
                            <span class="content-page">{{ $t('warning.content') }}</span>
                        </div>
                    </div>
                    <vs-pagination
                        class="custom-pagination"
                        :total ="totalPages"
                        :max="maxPageNumbers"
                        v-model="currentPage"
                        @change="onChangePages"
                    ></vs-pagination>
                </div>
            </div>
        </div>
      <PopupConfirm :active="activePopup" :on-success="onSuccess" :close="closePopup"/>
    </div>
</template>
<script>
import moment from 'moment';
import PopupConfirm from "../../v2/notify/PopupConfirm";
export default {
    components: {
      PopupConfirm
    },
    data(){
        return {
            confirmDelete:false,
            activePopup:false,
            //pagination
            pageNumber: 0,
            pageSize: 10,
            userInfo: {},
            totalPages: 0,
            pagenumbers: 0,
            totalElements: 0,
            countElementPage: 0,
            currentPage: 1,
            maxPageNumbers: 6,


            rowDatas: [],
            //header table
            headerTable: [
                {label: this.$t('warning.number')},
                {label: this.$t('warning.warningName')},
                {label: this.$t('warning.source')},
                {label: this.$t('warning.rules')},
                {label: this.$t('warning.formality')},
                {label: this.$t('warning.status')},
                {label: this.$t('warning.createdBy')}
            ],
            warning: {
                id: null
            }
        }
    },
    methods: {
        onSuccess(){
        if (this.confirmDelete){
          this.deleteRecord();
        }
      },
        closePopup(){
        this.activePopup = false;
        this.confirmDelete =false;
      },
        updateStatus: function(item){
            this.$vs.loading();
            const payload = {
                id: item.number
            }
            this.$processor.post('/warning/update-status', payload).then(() => {
                this.$vs.loading.close();
                this.initScreen();
                this.$vs.notify({
                    color: 'primary',
                    text: this.$t('warning.updateStatusSuccess'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle'
                })
            })
        },
        copyWarning: function(item){
          this.$vs.loading();
          this.$processor.post(`/warning/copy-warning/${item.number}`).then(() => {
            this.getListWarning();
            this.$vs.loading.close();
                this.$vs.notify({
                    color: 'primary',
                    text: this.$t('warning.copyWarningSuccess') + ' : ' + ` ${item.name}`,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle'
                })
            }).catch(err => {
              this.$vs.loading.close();
              return this.$vs.notify({
                text:
                  err.response.data.message ||
                  err.response.data.error_description ||
                  err.response.data.error,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger"
              });
          });
        },
        updateWarning: function(item) {
            this.$router.push(`/user/update-warning-v2?id=${item.number}`)
        },
        getImage: function(){
            this.userInfo = Object.assign({}, this.$store.state.AppActiveUser, JSON.parse(localStorage.getItem('userInfo')));
            const data = localStorage.getItem('userInfo');
            const info = JSON.parse(data);
            if(info.img){
            this.userInfo.img = info.img;
            }
        },
        onChangePages: function(event){
            this.pageNumber = parseInt(event) - 1;
            this.getListWarning();

        },
        getListWarning: function(){
            this.$vs.loading();
            const payload = {
                pageNumber: this.pageNumber,
                pageSize: this.pageSize
            }
            this.$processor.post('warning/get-all', payload).then((response) => {
                this.$vs.loading.close();
                this.countElementPage = response.data.content.length;

                this.rowDatas = response.data.content.map(warning => {
                    let listSourceName = [];
                    let rules = '';
                    if (warning.source.split(',').length == 8){
                        listSourceName.push(this.$t('warning.allSources'))
                    }
                    let listSourceWarning = warning.source.split(',');
                    listSourceWarning = listSourceWarning.map(el => parseInt(el));
                    if (listSourceWarning.length < 8) {
                        if (listSourceWarning.includes(104) && listSourceWarning.includes(105)) {
                            listSourceName.push('Facebook')
                        }
                        if (listSourceWarning.includes(101)) {
                            listSourceName.push('Website');
                        }
                        if (listSourceWarning.includes(113)) {
                            listSourceName.push('Blog');
                        }
                        if (listSourceWarning.includes(106) && listSourceWarning.includes(107)) {
                            listSourceName.push('Youtube');
                        }
                        if (listSourceWarning.includes(111) && listSourceWarning.includes(112)) {
                            listSourceName.push(this.$t('warning.forum'))
                        }
                    }
                    if (!warning.activeWarning) {
                        warning.bg = 'danger';
                        warning.color = '#F12B2C'
                    }else{
                        warning.bg = 'primary';
                        warning.color= '#2F80ED'
                    }
                    switch (warning.sourceType) {
                        case 0:
                            warning.sourceName = 'Facebook'
                            break;
                        case 1:
                            warning.sourceName = 'News'
                            break;
                        case 2:
                            warning.sourceName = 'Youtube'
                            break;
                        case 3:
                            warning.sourceName = 'Blog'
                            break;
                        case 4:
                            warning.sourceName = 'Forum'
                            break;
                        default:
                            warning.sourceName = 'Other'
                            break;
                    }
                    if (warning.warningTypeSetting == 0) {
                        let type = warning.conditionWarningType ? this.$t('warning.negative') : this.$t('warning.positive');
                        rules = type + ' ' + this.$t('warning.merge') + ' ' + warning.dataType;
                    }
                    let arrSettingClassification = [1,2,3,4,5]
                    if (arrSettingClassification.includes(warning.warningTypeSetting)) {
                        rules = this.ruleWarningSetting(warning.warningTypeSetting, warning.conditionWarningType, warning.dataType)
                    }
                    return {
                        number: warning.id,
                        name: warning.name,
                        source: listSourceName.toString().replaceAll(',', ', '),
                        status: warning.activeWarning,
                        rules: rules,
                        formality: 'Web push',
                        createdBy: warning.createdBy,
                        createdDate: moment(warning.createdDate).format('DD/MM/YYYY hh:mm:ss'),
                        bg: warning.bg,
                        color: warning.color,
                        sourceName: warning.sourceName
                    }
                })
                this.totalPages = parseInt(response.data.totalPages,10);
                this.pagenumbers = response.data.pageable.pageNumber;
                this.totalElements = response.data.totalElements;
            })
        },
        ruleWarningSetting: function(warningType, conditionsType, dataType){
            let rules = '';
            let classificationName = '';
            switch (warningType) {
                case 1:
                    classificationName = this.$t('warning.negative')
                    break;
                case 2:
                    classificationName = this.$t('warning.positive')
                    break;
                case 3:
                    classificationName = this.$t('warning.neutral')
                    break;
                case 4:
                    classificationName = this.$t('warning.share')
                    break;
                case 5:
                    classificationName = this.$t('warning.comment')
                    break;
            }
            switch (conditionsType) {
                case 2:
                    rules = classificationName + ' = ' + dataType + '%';
                    break;
                case 3:
                    rules = classificationName + ' < ' + dataType + '%';
                    break;
                case 4:
                    rules = classificationName + ' <= ' + dataType + '%';
                    break;
                case 5:
                    rules = classificationName + ' >= ' + dataType + '%';
                    break;
                case 6:
                    rules = classificationName + ' >= ' + dataType;
                    break;
            }
            return rules;
        },
        initScreen(){
            // this.getListFacebook();
            this.getImage();
            this.getListWarning();
        },
        confirmDeleteRecord(item) {
            this.warning.id = item.number;
            this.activePopup = true;
            this.confirmDelete = true;
        },
        deleteRecord() {
            this.$vs.loading();
            this.$processor.post(`/warning/delete/${this.warning.id}`).then(() => {
                this.initScreen();
                this.confirmDelete =false;
                this.activePopup = false;
                this.$vs.loading.close();
                return this.showDeleteSuccess();
            }).catch((err) => {
                this.confirmDelete =false;
                this.activePopup = false;
                this.$vs.loading.close();
                return this.$vs.notify({
                text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
                });
            });
        },
        showDeleteSuccess() {
            this.$store.commit('UPDATE_USER_SUCCESS', true);
            this.$vs.notify({
                color: 'primary',
                text: this.$t('warning.deleteWarningSuccess'),
                iconPack: 'feather',
                icon: 'icon-alert-circle',
            })
        }
    },
    async created(){
        this.initScreen();
        this.$eventBus.$on('i18n', () =>{
            this.initScreen();
        })
    }
}
</script>
<style scoped>
.custom-pagination {
    width: 50% !important;
}
.custom-card {
    height: 50px;
    display: flex !important;
    -webkit-box-shadow: 0px 4px 25px 0px rgb(0 0 0 / 2%) !important;
}
.text-page {
    font-size: 14px;
    color: #3ba1ff;
}
.content-page {
    color: #caccd6;
    font-size: 14px;
}
.type-source {
    color: #B9B9C3;
    font-size: 12px;
}
.text-code {
    font-size: 14px;
    color: #6E6B7B;
    font-weight: bold;
}
.inline-image {
    display: flex;
}
.badge {
    padding: .3rem .5rem;
    text-align: center;
    border-radius: .358rem;
    font-weight: 400 !important;
}
.border-bottom-dropdown {
    border-bottom: 1px solid #EBE9F1;
}
.detail-user {
    /* color: #6E6B7B; */
    font-size: 12px;
 }
.infomation {
    font-size: 12px;
    color: #B9B9C3;
}
.icon-custom-pause {
    color: rgba(241, 43, 44);
    background:rgba(241, 43, 44, 0.12);
    border-radius:10px;
    width: 18px;
    height: 18px;
    vertical-align: middle;
}
.icon-custom-play {
    color: rgba(47, 28, 237);
    background:rgba(47, 28, 237, 0.12);
    border-radius:10px;
    width: 18px;
    height: 18px;
    vertical-align: middle;
}
.source-name {
    font-size: 12px;
    color: #6E6B7B;
}
.text-action {
    font-size: 12px;
}
</style>
